module.exports = __webpack_public_path__ + "img/rgg_logo.c5830162.png";